import React from 'react';
import qs from 'qs';
import './styles.scss';

export class VerifyUser extends React.Component {
  componentDidMount() {
    this.props.clearUserStatuses();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.registerSuccess !== this.props.registerSuccess && this.props.registerSuccess) {
      this.props.history.push('/login');
    }
  }

  componentWillUnmount() {
    this.props.clearUserStatuses();
  }

  verifyUser = () => {
    this.props.clearUserStatuses();
    const { token } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    this.props.verifyUser(token);
  }

  render() {
    return (
      <div className="register-container">
        <h1 className="title">Final Step!</h1>
        <p className="subtitle">Click the button below to get started with DartMate.</p>
        {this.props.registerError ? <p className="signup-error-text">There was an error verifying your email.</p> : null}
        <button
          type="button"
          className="sign-up-button"
          onClick={this.verifyUser}
        >Confirm Email And Sign In
        </button>
      </div>
    );
  }
}

export default VerifyUser;
